export default __webpack_public_path__ + "static/media/ies_nuestrosPatrocinadores.b9005f9d.png";